// num of selections -> rules
export const additionalUkTuplesRules = {
	
	'31' :{
		pseudo: 'trixie',
		index: 31,
		indexesToTakeCombs: [2, 3],
		totalCombsExpected: 4
	},
	'32':{
		pseudo: 'patent',
		index: 32,
		indexesToTakeCombs: [1,2,3],
		totalCombsExpected: 7
	},
	'33':{
		pseudo: 'yankee11',
		index: 33,
		indexesToTakeCombs: [2, 3, 4],
		totalCombsExpected: 11
	},
	'34':{
		pseudo: 'lucky15',
		index: 34,
		indexesToTakeCombs: [1,2,3,4],
		totalCombsExpected: 15
	},
	'35': {
			pseudo: 'canadian',
			index: 35,
			indexesToTakeCombs: [2, 3, 4, 5],
			totalCombsExpected: 26
	},
	'36': {
			pseudo: 'lucky31',
			index: 36,
			indexesToTakeCombs: [1,2,3,4,5],
			totalCombsExpected: 31
	},
	'37': {
			pseudo: 'heinz',
			index: 37,
			indexesToTakeCombs: [2, 3, 4, 5, 6],
			totalCombsExpected: 57
	},
	'38': {
			pseudo: 'lucky63',
			index: 38,
			indexesToTakeCombs: [1,2,3,4,5,6],
			totalCombsExpected: 63
	},
	'39': {
			pseudo: 'triple_yankee', // TO DEVELOP
			index: 39,
			indexesToTakeCombs: [],
			totalCombsExpected: 33
	},
	'40': {
			pseudo: 'super_heinz', 
			index: 40,
			indexesToTakeCombs: [2, 3, 4, 5, 6, 7],
			totalCombsExpected: 120
	},
	'41': {
			pseudo: 'goliath', 
			index: 41,
			indexesToTakeCombs: [2, 3, 4, 5, 6, 7, 8],
			totalCombsExpected: 247
	},
	getAvaialableTuplesByOrdinaryCombinations: function(combinations, totalDraws) {
		let accumulatorCombination = combinations[totalDraws];
		let list = null;
		if (accumulatorCombination == 1) {
			switch(totalDraws) {
				case 3: { list = [additionalUkTuplesRules['31'], additionalUkTuplesRules['32']]; break;}
				case 4: { list = [additionalUkTuplesRules['33'], additionalUkTuplesRules['34']]; break;}
				case 5: { list = [additionalUkTuplesRules['35'], additionalUkTuplesRules['36']]; break;}
				case 6: { list = [additionalUkTuplesRules['37'], additionalUkTuplesRules['38'] /**, additionalUkTuplesRules['39'] */]; break;}
				case 7: { list = [additionalUkTuplesRules['40']]; break;}
				case 8: { list = [additionalUkTuplesRules['41']]; break;}
				default: { list = null; }
			}
		}
		if (list) {
			// check if the "sub" combinations are gt 0
			const definitiveList = [];
			for (let ka in list) {
				let totalCombs = 0;
				const additionalTuple = list[ka];
				for (let ki in additionalTuple.indexesToTakeCombs) {
					const index = additionalTuple.indexesToTakeCombs[ki];
					if (index === 'all_valued') {
						for (let kc in combinations) {
							totalCombs += combinations[kc];
						}
					}
					else {
						totalCombs += combinations[index];
					}
				}
				if (totalCombs == additionalTuple.totalCombsExpected) {
					definitiveList.push(additionalTuple);
				}
			}
			return definitiveList;

		}
		return null;
	},

	getTotalTuplesToAddInList: function() {
		const keys = Object.keys(additionalUkTuplesRules);
		let number = 0;
		for (let k in keys) {
			if (!isNaN(keys[k])) {
				number ++;
			}
		}
		return number;
	},
	
	getListOfAdditionalTuplesByOriginalTupleIndex: function(originalIndex) {
		const list = [];
		const keys = Object.keys(additionalUkTuplesRules);
		const cntMap = {};
		for (let k in keys) {
			const tupleKey = keys[k];
			if (!isNaN(tupleKey)) {
				const additionalTuple = additionalUkTuplesRules[tupleKey];
				for (let i in additionalTuple.indexesToTakeCombs) {
					const index = additionalTuple.indexesToTakeCombs[i];
					if ((index == originalIndex || index === 'all_valued')  && !cntMap[additionalTuple.index]) {
						cntMap[additionalTuple.index] = true;
						list.push(additionalTuple.index);
					}
				}
			}
		}
		return list;	
	},
	
	getAdditionalTuplesByIndexesList(list) {
		const keys = Object.keys(additionalUkTuplesRules);
		const returnMap = {};
		for (let k in keys) {
			const tupleKey = keys[k];
			if (!isNaN(tupleKey)) {
				const additionalTuple = additionalUkTuplesRules[tupleKey];
				const indexesToTakeCombsMap = {};
				let finalKey = '';
				for (let kia in additionalTuple.indexesToTakeCombs) {
					indexesToTakeCombsMap[additionalTuple.indexesToTakeCombs[kia]] = true;
				}
				if (Object.keys(indexesToTakeCombsMap).length > 0) {
					for (let ki = 0; ki < list.length; ki ++) {
						const originalIndex = list[ki];
						delete indexesToTakeCombsMap[originalIndex];
						finalKey = finalKey + originalIndex;
						if (ki < list.length - 1) {
							finalKey = finalKey + "_";
						}
					}
					if (Object.keys(indexesToTakeCombsMap).length === 0) {
						// it means that all the additionalTuple requirements has been satisfied. This key of original indexes is linked with this additionalTuple
						returnMap[finalKey] = additionalTuple;
					}
				}
			}
		}
		return returnMap;	
	}

};
window.additionalUkTuplesRules = additionalUkTuplesRules;
/** NB: THE ITALIAN TUPLES GOES FROM INDEX 1 TO 30. TO ADD THE UK TUPLES, FIRST I ENLARGE THE COMB ARRAY,
	THEN I ASSIGN THE ID STARTING FROM 31 TO THE FINAL ONE */
export function setAdditionalUkTuples(calculatedSystemData, totalDraws) {
	const combinations = calculatedSystemData.comb;
	let totalCombs = 0;
	for (let kc in combinations) {
		totalCombs += combinations[kc];
	}
	const tupleList = additionalUkTuplesRules.getAvaialableTuplesByOrdinaryCombinations(combinations, totalDraws);
	if (tupleList) {
		// increase the combination list to add the positions for the additional tuples
		const totalTuplesAvailable = additionalUkTuplesRules.getTotalTuplesToAddInList();
		for (let i = 0; i < totalTuplesAvailable.totalTuplesToAdd; i++) {
			combinations.push(0);
		}
		for (let it in tupleList) {
			let tupleCombs = 0;
			const tupla = tupleList[it];
			for (let i in tupla.indexesToTakeCombs) {
				const index = tupla.indexesToTakeCombs[i];
				if (index === 'all_valued') {
					tupleCombs += totalCombs;
				}
				else{
					tupleCombs += combinations[index];
				}
			}
			combinations[tupla.index] = tupleCombs;
		}
	}
	//window.combinations = combinations;
}
